module.exports = __webpack_public_path__ + "media/images/noise-d98116d873c9536d531b7fc8018be746.png";